export default __webpack_public_path__ + "img/Poppins-Bold_1259743.woff";